const staticDaffyOrigin = "https://static.daffy.org";

export function toStatic(pathname: string) {
  return new URL(pathname, staticDaffyOrigin).href;
}
